angular.module('GebotService', []).factory('Gebot', ['$resource',
    function ($resource) {
        return $resource('/api/gebote/:geboteId', {
            geboteId: '@id'
        }, {
            update: {
                method: 'PUT'
            }
        });
    }
]);